import React from 'react'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import { Badge } from 'react-bootstrap'
import { OUR_USER } from '../../constants/configs'

const LotteryList = ({ lotteries, onUserInfoClick, isRoundClosed }) => {
  return (
    <Row>
      {lotteries === undefined || lotteries.length === 0 ? (
        <Col className="my-3">ไม่พบข้อมูล</Col>
      ) : (
        lotteries?.map((lottery, i) => {
          const user = isRoundClosed ? (lottery?.user?.id ? lottery?.user : OUR_USER) : lottery?.user
          const userName = user?.firstName + ' ' + user?.lastName || '-'
          return (
            <Col sm={6} md={6} lg={4} xl={3} xxl={2} className="my-3" key={i}>
              <div className="py-1 d-flex justify-content-between">
                <span>{lottery.matrixId}</span>
                <span className="text-right">
                  {lottery.sourceBook || ''} / {lottery.sourceFile || ''}
                </span>
              </div>

              <ImageLotteries src={`${lottery.image.slice(0, -4)}_M.jpg`} />
              <Info>
                <RowInfo>
                  <div className="text-right">รหัสผู้ใช้งาน</div>
                  <Badge
                    variant="primary light"
                    style={{ cursor: 'pointer' }}
                    onClick={() => onUserInfoClick(user?.userId)}
                  >
                    {user?.userId || '-'}
                  </Badge>
                </RowInfo>
                <RowInfo>
                  <div className="text-right">ชื่อลูกค้า</div>
                  <div className="text-right">{userName.length <= 1 ? '-' : userName}</div>
                </RowInfo>
                <RowInfo>
                  <div className="text-right">ชื่อเล่น</div>
                  <div className="text-right">{user?.nickName || '-'}</div>
                </RowInfo>
              </Info>
            </Col>
          )
        })
      )}
    </Row>
  )
}

export default LotteryList

const ImageLotteries = styled.img`
  width: 100%;
`

const HindAndShow = styled.span`
  cursor: pointer;
`

const Info = styled.div`
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const RowInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
